import { UseFormReturn } from 'react-hook-form';
import {
  Button,
  Box,
  Typography,
  Alert,
  CircularProgress,
} from '@mui/material';
import { Send as SendIcon } from '@mui/icons-material';

import { BaseForm } from './BaseForm';
import { FormField } from './FormField';
import { contactSchema, ContactFormData } from '@/utils/validation.ts';

interface ContactFormProps {
  onSubmit: (data: ContactFormData) => void | Promise<void>;
  loading?: boolean;
  error?: string;
  success?: string;
}

export const ContactForm = ({
  onSubmit,
  loading = false,
  error,
  success,
}: ContactFormProps) => {
  const defaultValues: Partial<ContactFormData> = {
    name: '',
    email: '',
    subject: '',
    message: '',
  };

  return (
    <BaseForm
      title="Обратная связь"
      schema={contactSchema}
      defaultValues={defaultValues}
      onSubmit={onSubmit}
      loading={loading}
    >
      {(form: UseFormReturn<ContactFormData>) => (
        <>
          {error && (
            <Alert variant="filled" severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          {success && (
            <Alert variant="filled" severity="success" sx={{ mb: 2 }}>
              {success}
            </Alert>
          )}

          <FormField
            name="name"
            control={form.control}
            label="Ваше имя"
            placeholder="Введите ваше имя"
          />

          <FormField
            name="email"
            control={form.control}
            label="Email"
            type="email"
            placeholder="your@email.com"
          />

          <FormField
            name="subject"
            control={form.control}
            label="Тема сообщения"
            placeholder="Кратко опишите тему"
          />

          <FormField
            name="message"
            control={form.control}
            label="Сообщение"
            multiline
            rows={4}
            placeholder="Опишите ваш вопрос или предложение подробно..."
          />

          <Box display="flex" gap={2} justifyContent="center">
            <Button
              type="button"
              variant="outlined"
              onClick={() => form.reset()}
              disabled={loading}
            >
              Очистить
            </Button>
            <Button
              type="submit"
              variant="contained"
              startIcon={
                loading ? <CircularProgress size={20} /> : <SendIcon />
              }
              disabled={loading || !form.formState.isValid}
            >
              {loading ? 'Отправка...' : 'Отправить сообщение'}
            </Button>
          </Box>

          <Typography
            variant="body2"
            color="text.secondary"
            align="center"
            sx={{ mt: 2 }}
          >
            Мы ответим на ваше сообщение в течение 24 часов
          </Typography>
        </>
      )}
    </BaseForm>
  );
};
